export const NavbarData = [
  {
    titleText: "Yojana Dashboard",
    title: "Yojana Dashboard",
    pathUrl: "VidhanSabhaDashboard",
    iconClass: "dashboard",
  },
  {
    titleText: "Voters Family",
    // title: "Voters Yojana",
    title: "Voters Family",
    pathUrl: "MemberList",
    iconClass: "users",
  },
  {
    titleText: "E-Office",
    title: "E-Office",
    pathUrl: "https://narendramodieoffice.com/EOffice/Access.aspx?4/6E4C37A1-48AD-42E4-B6F8-D27E23A02829",
    iconClass: "address-book",
    isExternal: true,
  },
];
